export default {
  "models": {
    "remark": "notas",
  },

  "farms": {
    "plural": "granja",
    "singular": "granja",
  },
  "ponds": {
    "plural": "estanque",
    "singular": "estanque",
  },
  "cycles": {
    "plural": "ciclo",
    "singular": "ciclo",
  },

  "cyclePredictions": {
    "plural": "predicción",
    "singular": "predicción",

    "age": "DdC",
    "weight": "PP (g)",
    "total_weight": "biomasa (kg)",
    "survival_rate": "TS (%)",
    "size": "talla",
    "selling_price": "precio de venta",

    "pond": "estanque",
    "today": "hoy",
    "total": "total"
  },
  "cycleActuals": {
    "plural": "actuals",
    "singular": "actual"
  },

  "shrimpPrices": {
    "plural": "precio del camarón",
    "singular": "precio del camarón",

    "size": "talla",
  },

  "multiMeasurements": {
    "plural": "multi measurements",
    "singular": "multi measurement",

    "id": "ID",
    "pond_id": "pond ID",
    "cycle_id": "cycle ID",
    "measured_at": "medido en",

    "ph": "pH",
    "salinity": "salinidad",
    "temperature": "temperature",
    "do": "dissolved oxygen",
    "transparency": "transparency",
    "water_level": "water level",
    "do_percent": "dissolved oxygen percent",
    "ec": "electrical conductivity",
    "tds": "total dissolves solids",
    "gravity": "sea water specific gravity",
    "color": "colorr",
    "weather": "clima",
    "turbidity": "turbidity",
    "tom": "total organic matter",
    "ammonia": "amoníaco",
    "ammonium": "amonio",
    "total_ammonia": "amoníaco total",
    "nitrit": "nitrito",
    "nitrat": "nitrato",
    "phosphate": "fosfato",
    "bicarbonat": "bicarbonato",
    "carbonat": "carbonato",
    "alkalinity": "alcalinidad",
    "magnesium": "magnesio",
    "calcium": "calcio",
    "hardness": "hardness",
    "potassium": "potasio / kalium",
    "orp": "oxidation-reduction potential",
    "ga": "alga verde",
    "bga": "alga verde azul",
    "dino": "dinoflagellata",
    "diatom": "diatom",
    "euglenophyta": "euglenophyta",
    "haptyophyta": "haptyophyta",
    "gba": "algas pardas doradas",
    "gga": "algas verdes doradas",
    "yga": "algas verdes amarillas",
    "floc": "floc",
    "prozoo": "protozoa",
    "zoo": "zoo",
    "total_plankton": "plancton total",
    "yellow": "yellow vibrio",
    "green": "green vibrio",
    "luminance": "luminance",
    "black": "black vibrio",
    "total_vibrio": "vibrión total",
    "total_bacteria": "bacterias totales",

    "temperature_short": "temp",
    "salinity_short": "sal",
    "do_short": "OD",
    "ammonia_short": "NH3",
    "nitrat_short": "NO3",
    "nitrit_short": "NO2",
    "alkalinity_short": "alcalinidad",
    "hardness_short": "dureza",
    "calcium_short": "Ca",
    "magnesium_short": "Mg",
    "carbonat_short": "CO3",
    "bicarbonat_short": "HCO3",
    "tom_short": "TOM",
    "orp_short": "ORP",
    "ammonium_short": "NH4",
    "phosphate_short": "PO4",
    "total_ammonia_short": "total NH3",
    "potassium_short": "potassium",
    "total_plankton_short": "total plankton",
    "ga_short": "GA",
    "bga_short": "BGA",
    "dino_short": "Dino",
    "diatom_short": "diatom",
    "prozoo_short": "prozoo",
    "floc_short": "floc",
    "gba_short": "GBA",
    "euglenophyta_short": "euglenophyta",
    "zoo_short": "zoo",
    "haptyophyta_short": "haptyophyta",
    "gga_short": "GGA",
    "yga_short": "YGA",
    "total_bacteria_short": "bacterias totales",
    "total_vibrio_short": "vibrión total",
    "yellow_short": "yellow",
    "green_short": "green",
    "black_short": "black",
    "luminance_short": "luminance",

    "measured_date": "Fecha",
    "measured_time": "Tiempo",

    "cycle": "ciclo",
    "pond": "estanque",
    "farm": "farm",

    "waterQuality": "Calidad del agua",
    "chemical": "Químico",
    "plankton": "Plancton",
    "microbiology": "Microbiología"
  },
  "waterQualityMultiMeasurements": {
    "plural": "calidad del agua",
    "singular": "calidad del agua"
  },
  "chemicalMultiMeasurements": {
    "plural": "químico",
    "singular": "químico"
  },
  "planktonMultiMeasurements": {
    "plural": "plancton",
    "singular": "plancton"
  },
  "microbiologyMultiMeasurements": {
    "plural": "microbiología",
    "singular": "microbiología"
  },
  "feeds": {
    "plural": "Alimentación",
    "singular": "Alimentación",

    "id": "ID",
    "cycle_id": "cycle ID",
    "stock_id": "stock ID",
    "quantity": "quantity (kg)",
    "logged_at": "logged at",
    "remark": "notas",

    "feed_at": "feed at",
    "logged_date": "fecha",
    "logged_time": "hora",
    "accumulation": "acumulación (kg)",
    "age": "años",
    "fasting": "ayuno",

    "accumulation_short": "accum. (kg)",
    "remark_short": "nota",

    "cycle": "ciclo",
    "pond": "estanque",
    "farm": "granja",
    "stock": "stock"
  },
  "fastings": {
    "plural": "ayuno",
    "singular": "ayuno",

    "id": "ID",
    "cycle_id": "cycle ID",
    "logged_date": "fecha",
    "fasting": "ayuno",
    "remark": "notas",

    "cycle": "ciclo",
    "pond": "estanque",
    "farm": "granja"
  },
  "feedingTrayControls": {
    "plural": "Canasta de alimentación",
    "singular": "Canasta de alimentación",

    "id": "ID",
    "logged_at": "logged at",
    "feed_logged_at": "feed logged at",
    "cycle_id": "cycle ID",
    "tray_number": "número de bandeja",
    "feed_remaining_percent": "porcentaje restante de alimentación",
    "remark": "notas",

    "logged_time": "hora",
    "logged_date": "fecha",
    "remark_short": "nota",

    "tray": "bandeja",
    "empty": "vacío",
    "empty_short": "E",
    "few": "pocos",
    "few_short": "F",
    "plenty": "infinidad",
    "plenty_short": "P",
  },
  "samplings": {
    "plural": "Muestreo",
    "singular": "Muestreo",

    "id": "ID",
    "cycle_id": "cycle ID",
    "average_weight": "MBW (g)",
    "survival_rate": "tasa de supervivencia",
    "sampled_at": "fecha",
    "remark": "notas",

    "average_growth": "ADG",
    "adg": "ADG",
    "remark_short": "nota"
  },
  "treatments": {
    "plural": "Tratamiento",
    "singular": "Tratamiento",

    "id": "ID",
    "pond_id": "pond ID",
    "stock_id": "stock ID",
    "name": "nombre",
    "quantity": "cantidad",
    "treated_at": "treated at",
    "remark": "notas",

    "remark_short": "note"
  },
  "harvests": {
    "plural": "Cosecha",
    "singular": "Cosecha",

    "id": "ID",
    "cycle_id": "cycle ID",
    "weight": "peso (kg)",
    "size": "talla",
    "harvested_at": "fecha",
    "selling_price": "precio de venta",
    "status": "type",
    "remark": "notas",
    "buyer": "comprador",

    "price_per_kg": "precio por kg",
    "total_price": "precio total",

    "weight_short": "peso",
    "remark_short": "nota"
  },
  "mortalities": {
    "plural": "Mortalidad",
    "singular": "Mortalidad",

    "id": "ID",
    "cycle_id": "cycle ID",
    "quantity": "cantidad",
    "average_weight": "peso promedio",
    "recorded_at": "fecha",
    "remark": "notas",

    "size": "talla",
    "total_weight": "peso (kg)",

    "total_weight_short": "peso",
    "remark_short": "nota"
  },
  "cycleDiseases": {
    "plural": "Enfermedad",
    "singular": "Enfermedad",

    "id": "ID",
    "cycle_id": "cycle ID",
    "disease_id": "disease ID",
    "laboratory_id": "laboratory ID",
    "other_disease": "otra enfermedad",
    "logged_at": "logged at",
    "positive": "positivo",
    "remark": "notas",

    "logged_date": "fecha",
    "logged_time": "hora",
    "image": "foto",

    "remark_short": "nota",

    "disease": "enfermedad"
  },

  "regions": {
    "plural": "regiones",
    "singular": "región",

    "outside_indonesia": "FUERA DE INDONESIA"
  },

  "autoFeederPond": {
    "plural": "auto feeder ponds",
    "singular": "auto feeder pond",

    "id": "ID",
    "pond_id": "pond ID",
    "auto_feeder_address": "address",
    "name": "name",
    "mode": "mode",
    "debit": "debit",
    "state": "state",

    "ip": "IP",
    "startTime": "start time",
    "endTime": "end time",
    "onTime": "timer ON",
    "feeds": "feeds",
    "updatedAt": "updated at",
    "uploadedAt": "uploaded at",
    "lastOnAt": "last ON at",

    "timesPerDay": "times per day",
    "timesPerPeriod": "throw times per feeding",
    "intervalPerPeriod": "interval per period",
    "intervalPeriod": "feed duration",

    "feedsPerDay": "feeds per day",

    "updated": "updated",
    "uploaded":"uploaded",
    "created": "created"
  },
}
